import { Link } from "react-router-dom";
import { useT } from "@/context/LangContext";
import SocialBar from "@/components/SocialBar";

export default function Footer() {
  const t = useT();
  return (
    <footer className="bg-[#0A0F1A] text-white mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="kicker !text-[#FF6B00]">{t("footer.about.kicker")}</p>
          <h3 className="font-display text-2xl mt-3 mb-4 max-w-md">{t("footer.about.desc1")}</h3>
          <p className="text-white/60 text-sm max-w-sm">{t("footer.about.desc2")}</p>
          <p className="text-white/40 text-xs italic mt-4">{t("footer.tagline")}</p>

          <div className="mt-8">
            <p className="kicker text-white/40 mb-3">{t("footer.follow")}</p>
            <SocialBar variant="dark" testIdPrefix="footer-social" />
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="kicker text-white/40">{t("footer.nav")}</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-[var(--accent)]">{t("nav.services")}</Link></li>
            <li><Link to="/produits" className="hover:text-[var(--accent)]">{t("nav.products")}</Link></li>
            <li><Link to="/etudes" className="hover:text-[var(--accent)]">{t("nav.study")}</Link></li>
            <li><Link to="/a-propos" className="hover:text-[var(--accent)]">{t("nav.about")}</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--accent)]">{t("nav.contact")}</Link></li>
          </ul>
          <p className="kicker text-white/40 mt-6">COIF · Étudier à l'étranger</p>
          <a href="https://www.facebook.com/share/1DStDgKxz8/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-2 text-sm hover:text-[var(--accent)]" data-testid="footer-coif-fb">
            <span className="inline-block w-2 h-2 rounded-full bg-blue-400" /> Suivre COIF sur Facebook
          </a>
        </div>
        <div className="md:col-span-4">
          <p className="kicker text-white/40">{t("footer.contact")}</p>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li>📍 {t("contact.office.yiwu.addr")}</li>
            <li>📍 {t("contact.office.gz.addr")}</li>
            <li>
              <a href="mailto:info@negosino.com" className="hover:text-[var(--accent)]" data-testid="footer-email">✉️ info@negosino.com</a>
            </li>
            <li>
              <a href="https://wa.me/8619878000805" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--accent)] inline-flex items-center gap-2" data-testid="footer-wa-1">
                <span className="inline-block w-2 h-2 rounded-full bg-green-400" /> +86 198 7800 0805
              </a>
            </li>
            <li>
              <a href="https://wa.me/8618344323165" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--accent)] inline-flex items-center gap-2" data-testid="footer-wa-2">
                <span className="inline-block w-2 h-2 rounded-full bg-green-400" /> +86 183 4432 3165
              </a>
            </li>
            <li>
              <a href="https://wa.me/8613250331280" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--accent)] inline-flex items-center gap-2" data-testid="footer-wa-3">
                <span className="inline-block w-2 h-2 rounded-full bg-green-400" /> +86 132 5033 1280
              </a>
            </li>
            <li>
              <a href="https://wa.me/221774419060" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--accent)] inline-flex items-center gap-2" data-testid="footer-wa-dakar">
                <span className="inline-block w-2 h-2 rounded-full bg-green-400" /> 🇸🇳 +221 77 441 90 60 <span className="text-white/40 text-xs">Dakar</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} NEGOSINO — {t("footer.rights")}</p>
          <p className="brand-mark text-[12vw] md:text-[8vw] leading-none text-white/5">negosino.</p>
        </div>
      </div>
    </footer>
  );
}
